module.exports = __webpack_public_path__ + "img/w3_phone_grey.bf5fe97d.png";